import { render, staticRenderFns } from "./createtask.vue?vue&type=template&id=166c4d7f&"
import script from "./createtask.vue?vue&type=script&lang=ts&"
export * from "./createtask.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "createtask.vue"
export default component.exports